<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="50%">
    <ElForm ref="saveFormRef" v-model="form" :model="form" :rules="rules" label-width="140px">
      <ElFormItem label="模板名称" prop="name">
        <el-input type="text" v-model="form.name" class="plan-input" :maxlength="50" show-word-limit placeholder="" />
      </ElFormItem>
      <ElFormItem label="描述" prop="remark">
        <el-input :rows="8" type="textarea" v-model="form.remark" class="plan-input" :maxlength="200" show-word-limit placeholder="" />
      </ElFormItem>
    </ElForm>
    <p style="font-size: 12px; margin-left: 140px">
      模板将会保存“账号”“推广目的”“项目基础信息”“定向包”“计划基础信息”“创意素材”“文案包”“落地页”的信息
    </p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="saveData">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script setup>
import { reactive, ref, onMounted, inject } from 'vue'
import { addtemplate, savetemplate } from '@/api/ptom.data.model'
import { Message } from 'view-design'
import { getTemplateConditionInfo } from '../../hooks/useToutiaoPlanTemplates.js'
// eslint-disable-next-line
const { title, menuId } = defineProps({
  title: String,
  menuId: String
})
// eslint-disable-next-line
const emits = defineEmits(['setValue'])
const { configForm } = inject('configForm')
const rules = {
  name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }]
}
const saveFormRef = ref(null)
const dialogVisible = ref(false)
const submitLoading = ref(false)
const form = ref({
  name: '',
  remark: ''
})
const open = () => {
  dialogVisible.value = true
}
const close = () => {
  dialogVisible.value = false
}

const saveData = async () => {
  const { id, ...restFields } = form.value
  const data = {
    menuId,
    ...restFields,
    conditionInfo: getTemplateConditionInfo(configForm.value)
  }
  submitLoading.value = true

  try {
    await saveFormRef.value.validate()
    // 保存模板时只修改名称和备注，其他的不改设置为 undefined 不传参
    const result = id ? await savetemplate({ ...data, id, conditionInfo: undefined }) : await addtemplate(data)
    submitLoading.value = false
    if (!result) return
    Message.success('保存成功')
    close()
  } catch (e) {
    submitLoading.value = false
  }
}
onMounted(() => {})
// eslint-disable-next-line
defineExpose({
  open,
  close,
  setForm: (row) => {
    form.value = row
  }
})
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 20px;
}
</style>
